import { useEffect, useRef, useState, Fragment } from 'react';
import { Drawer, message, Popconfirm } from 'antd';
import { config } from './config';
import {
  getActivityProductShopLimitList,
  getActivityProductShopLimitDetail,
  deleteActivityProductShopLimit
} from '@/services/product';
import AddOrEditForm from './addOrEdit';
import {
  SActionBtn,
  SLowcodeList,
  STableActions,
  SMessage,
} from 'shj-components'

const LimitSet = (props: any) => {
  const { show, setVisible, pid, psid, companyList = [] } = props;

  const listRef = useRef<any>();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [id, setId] = useState(0);

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize } = values;
        //增加查询统计数量
        const where = { activityProductId: pid };

        getList(where, [current, pageSize], function (records, total) {
          resolve({ records, total });
        });
      } catch (e) {
        console.log(e);
        reject({ success: false });
      }
    });
  };

  const getList = async (data = {}, pages = [1, 10], backFn = (a, b) => ({})) => {
    try {
      const res: any = await getActivityProductShopLimitList({
        params: {
          pageId: pages[0],
          pageSize: pages[1],
        },
        data,
      });
      const records = res?.list;
      const all = res?.count;
      backFn(records, all);
    } catch (err) {
      console.log(err);
    }
  };
  const onAdd = () => {
    setId(0);
    setVisibleEdit(true);
    setEditData({});
  };
  const editAndAddBox = async (record: any) => {
    setId(record.id);
    setVisibleEdit(true); //
    const res: any = await getActivityProductShopLimitDetail(record.id);
    if (res.id) {
      setEditData(res);
    }
  };
  const closeModal = () => {
    setVisible(false);
  };
  const onDelete = async (record: any) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteActivityProductShopLimit(record.id);
          if (res.errorCode === 0) {
            message.success(res.message || '删除成功');
            (listRef as any)?.current?.reload();
          } else {
            message.error('删除失败');
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除');
      },
    });
  };

  const extension = {
    request: { fetchList },
    events: { onAdd },
    customRender: {
      editCell(text: any, record: object) {
        return (
          <Fragment>
            <STableActions>
              <SActionBtn onClick={editAndAddBox.bind(this, record)}>编辑</SActionBtn>
              <SActionBtn danger onClick={() => onDelete(record)}>删除</SActionBtn>
            </STableActions>
          </Fragment>
        );
      },
    },
  };

  return (
    <Drawer
      title={'公司限量设置'}
      width={700}
      onClose={closeModal}
      bodyStyle={{ padding: 15 }}
      visible={show}
      destroyOnClose={true}
    >
      <SLowcodeList searchMode="group" config={config} ref={listRef} {...extension} />
      {setVisibleEdit ? <AddOrEditForm
        companyList={companyList}
        editData={editData}
        setVisible={setVisibleEdit}
        show={visibleEdit}
        id={id}
        pid={pid}
        psid={psid}
        listRef={listRef}
      /> : null}
    </Drawer>
  );
};
export default LimitSet;
